<div class="container-fluid content-wrapper">

  <div class="page-title-wrapper">
    <h1 class="page-title">Regular table</h1>
    <span class="page-subtitle">Simple table with or without stripes. To remove the stripes, just remove the <code>table-striped</code> class.</span>
  </div>

  <div class="row">
    <div class="col-12 table-wrapper table-responsive">
      <table mat-table [dataSource]="dataSource" class="table table-borderless table-striped">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef> ID </th>
          <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
        <ng-container matColumnDef="country">
          <th mat-header-cell *matHeaderCellDef> Country </th>
          <td mat-cell *matCellDef="let element"> {{element.country}} </td>
        </ng-container>
        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef> City </th>
          <td mat-cell *matCellDef="let element"> {{element.city}} </td>
        </ng-container>
        <ng-container matColumnDef="birthday">
          <th mat-header-cell *matHeaderCellDef> Birthday </th>
          <td mat-cell *matCellDef="let element"> {{element.birthday}} </td>
        </ng-container>
        <ng-container matColumnDef="age">
          <th mat-header-cell *matHeaderCellDef> Age </th>
          <td mat-cell *matCellDef="let element"> {{element.age}} </td>
        </ng-container>
        <ng-container matColumnDef="salary">
          <th mat-header-cell *matHeaderCellDef> Salary </th>
          <td mat-cell *matCellDef="let element"> {{element.salary}} </td>
        </ng-container>
         <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
         <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
</div>
